<template>
    <div class="box-home">
        <div class="home-top">
        </div>
        <div class="home-top-option">
              <div class="top-in">
                <div class="in-top">上午好，{{user.userName}}!</div>
                <div class="in-bottom">I'm glad to see you again.</div>
            </div>
            <img class="homt-top-img" src="../../../assets/img/home-logos.svg" alt="" />
      </div>
           
        <div class="home-top-tiem">
             <div style="padding: 16px">
                <el-date-picker @change="changes" :clearable="false" style="width: 120px" format="yyyy 年 " v-model="year" type="year" placeholder="选择年" value-format="yyyy"> </el-date-picker>
            </div>
        </div>
        <div class="home-in">
            <div class="in-left">
                <div style="width: 100%; height: 100%" id="in-left-ech"></div>
            </div>
            <div class="in-right">
                <div style="width: 100%; height: 100%" id="in-right-ech"></div>
            </div>
        </div>
        <div class="home-bottom">
            <div class="bottom-left">
                <div style="width: 100%; height: 100%" id="bottom-left-ech"></div>
            </div>
            <div class="bottom-right">
                <div style="width: 100%; height: 100%" id="bottom-right-ech"></div>
            </div>
        </div>
    </div>
</template>

<script>
import https, { fetchPost } from '../../../../https.js';
// require('echarts/theme/macarons') // echarts theme
// // 引入基本模板
// let echarts = require('echarts/lib/echarts')
// // 引入柱状图组件
// require('echarts/lib/chart/bar')
// // 引入提示框和title组件
// require('echarts/lib/component/tooltip')
// require('echarts/lib/component/title')
export default {
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '500px'
        },
        height: {
            type: String,
            default: '300px'
        }
    },
    data() {
        return {
            year: `${new Date().getFullYear()}`,
            chart: null,
            user:localStorage.getItem('user'),
            countCurrMonthArchiveHandleDataForm: {
                //  本月档案处理统计
                groupedCount: 0, //  已分组数量
                groupingCount: 0, //  分组中数量
                bookedCount: 0, //  已成册数量
                bookingCount: 0 //  成册中数量
            }
        };
    },
    created: function () {},
    mounted() {
        this.user = JSON.parse(this.user)
        window.onresize = () => {
            return (() => {
                this.$nextTick(() => {
                    this.initCountBookedFileChart(true);
                    this.initCountCurrMonthUploadFileChart(true);
                    this.initCountCompanyUploadFileChart(true);
                    this.initCountEachMonthBookedFileChart(true);
                });
            })();
        };
        this.initCountCurrMonthUploadFileChart();
        //  init 本月上传文件数量统计
        // this.getCountCurrMonthArchiveHandleData();  //  load 本月档案处理统计
        this.initCountBookedFileChart(); //  init 累计成册文件数量统计
        this.initCountCompanyUploadFileChart(); //  init 集团实体上传文件数量统计
        this.initCountEachMonthBookedFileChart(); //  init 每月成册文件数量统计图表
        // this.initCountEachMonthBookDataChart();        //  init 每月册数统计图表
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    methods: {
        changes(e){
            if(!e){
                this.year = `${new Date().getFullYear()}`
            }
            this.initCountBookedFileChart();
            this.initCountCurrMonthUploadFileChart();
            this.initCountCompanyUploadFileChart();
            this.initCountEachMonthBookedFileChart();
        },
        initCountCurrMonthUploadFileChart(e) {
            var chartDom = document.getElementById('in-left-ech');
            var myChart = this.$echarts.init(chartDom);
            // let countCurrMonthUploadFileChart = this.$echarts.init(document.getElementById('countCurrMonthUploadFileChart'));
            var option;
            option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        
                    }
                },
                lineStyle: {
                    type: 'dashed'
                },
                title: {
                    text: '集团实体上传文件数量统计',
                    textStyle: {
                        fontSize: '16',
                        fontWeight: 'bold',
                    },
                    x:'16px',
                    y:'16px'
                },
                legend: {
                    data: ['原始凭证', '记账凭证'],
                },
                color: ['#0065b1', '#f1ae7e'],
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                     axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#C2C7CC'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false // 不显示坐标轴刻度线
                    },
                    axisLine: {
                        show: false // 不显示坐标轴线
                    },
                    axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    }
                },
                grid: {
                    x: 50,
                    y: 65,
                    x2:16,
                    y2: 30,
                    borderWidth: 1
                },
                series: [
                    {
                        barWidth: 20,
                        backgroundStyle: {
                            color: 'rgba(0, 0, 0, 0)'
                        },
                        data: [],
                        type: 'bar',
                        showBackground: true,
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 1, color: '#0065B1' },
                                { offset: 0.999, color: '#fff' },
                                { offset: 0.75, color: '#a7cae5' },
                                { offset: 0.5, color: '#78add6' },
                                { offset: 0.25, color: '#3686c2' },
                                { offset: 0, color: '#0065B1' }
                            ])
                        },
                        emphasis: {
                            itemStyle: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 1, color: '#fff' },
                                    { offset: 0.75, color: '#a7cae5' },
                                    { offset: 0.5, color: '#78add6' },
                                    { offset: 0.25, color: '#3686c2' },
                                    { offset: 0, color: '#0065B1' }
                                ])
                            }
                        }
                    }
                ]
            };
            myChart.showLoading();
            myChart.resize();
            myChart.setOption(option);
            //  显示 图表loading条
            this.getCountCurrMonthUploadFile(myChart);
        },
        initCountBookedFileChart(e) {
            var chartDom = document.getElementById('in-right-ech');
            var myChart = this.$echarts.init(chartDom);
            var option;
            option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow',
                    label: {
                        show: true
                    }
                    }
                },
                title: {
                    text: '成册情况统计',
                    textStyle: {
                        fontSize: '16',
                        fontWeight: 'bold',
                    },
                     x:'16px',
                    y:'16px'
                },
                legend: {
                    x: 'right', // 'center' | 'left' | {number}
                    y: 'top', // 'center' | 'bottom' | {numbe
                    padding: [20, 16, 0, 0]
                },
                color: ['#0065b1', '#f1ae7e'],
                grid: {
                   x: 50,
                    y: 65,
                    x2:16,
                    y2: 30,
                    borderWidth: 1
                },
                dataset: {
                    source: [
                        ['product', '已成册', '成册中'],
                        ['1月', 0, 0],
                        ['2月', 0, 0],
                        ['3月', 0, 0],
                        ['4月', 0, 0],
                        ['5月', 0, 0],
                        ['6月', 0, 0],
                        ['7月', 0, 0],
                        ['8月', 0, 0],
                        ['9月', 0, 0],
                        ['10月', 0, 0],
                        ['11月', 0, 0],
                        ['12月', 0, 0]
                    ]
                },
                xAxis: { type: 'category' ,
                 axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#C2C7CC'
                        }
                    }},
                yAxis: {
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                     axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#C2C7CC'
                        }
                    }
                },
                series: [
                    {
                        barWidth: 10,
                        type: 'bar'
                    },
                    {
                        barWidth: 10,
                        type: 'bar'
                    }
                ]
            };
            myChart.resize();
            myChart.showLoading();
            myChart.setOption(option);
            this.getCountBookedFile(myChart);
        },
        initCountCompanyUploadFileChart(e) {
            //  init 集团实体上传文件数量统计
            var chartDom = document.getElementById('bottom-left-ech');
            var myChart = this.$echarts.init(chartDom);
            var option;
            option = {
                title: {
                    text: '分组情况统计',
                    textStyle: {
                        fontSize: '16',
                        fontWeight: 'bold'
                    },
                     x:'16px',
                    y:'16px'
                },
                legend: {
                    x: 'right',
                    y: 'top',
                    padding: [16, 16, 0, 0]
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow',
                    label: {
                        show: true
                    }
                    }
                },
                color: ['#0065b1', '#f1ae7e', '#7f8af0'],
                grid: {
                    x: 50,
                    y: 65,
                    x2:16,
                    y2: 30,
                    borderWidth: 1
                },
                dataset: {
                    source: [
                        ['product', '已分组记账凭证', '已分组原始凭证', '未分组记账凭证'],
                        ['1月', 0, 0, 0],
                        ['2月', 0, 0, 0],
                        ['3月', 0, 0, 0],
                        ['4月', 0, 0, 0],
                        ['5月', 0, 0, 0],
                        ['6月', 0, 0, 0],
                        ['7月', 0, 0, 0],
                        ['8月', 0, 0, 0],
                        ['9月', 0, 0, 0],
                        ['10月', 0, 0,0],
                        ['11月', 0, 0, 0],
                        ['12月', 0, 0, 0]
                    ]
                },
                xAxis: { type: 'category'  ,
                 axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#C2C7CC'
                        }
                    }
               },
                yAxis: {
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                        }
                    },
                    axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#C2C7CC'
                        }
                    }
                },
                series: [
                    {
                        barWidth: 10,
                        type: 'bar'
                    },
                    {
                        barWidth: 10,
                        type: 'bar'
                    },
                    {
                        barWidth: 10,
                        type: 'bar'
                    }
                ]
            };
            myChart.showLoading();
            myChart.resize();
            myChart.setOption(option);
            this.getCountCompanyUploadFile(myChart);
        },
        initCountEachMonthBookedFileChart(e) {
            var chartDom = document.getElementById('bottom-right-ech');
            var myChart = this.$echarts.init(chartDom);
            var option;
            option = {
                title: {
                    text: '上传文件数量统计',
                    textStyle: {
                        fontSize: '16',
                        fontWeight: 'bold'
                    },
                     x:'16px',
                    y:'16px'
                },
                grid: {
                    x: 50,
                    y: 65,
                    x2:16,
                    y2: 30,
                },
               
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['原始凭证', '记账凭证'],
                    x: 'right', // 'center' | 'left' | { number }
                    y: 'top', // 'center' | 'bottom' | { numbe }
                    padding: [16, 16, 0, 0]
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                     axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#C2C7CC'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',

                        }
                    },
                     axisLabel:{
                        show:true,
                        textStyle:{
                            color:'#999999'
                        }
                    },
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#C2C7CC'
                        }
                    }
                },
                series: [
                    {
                        name: '原始凭证',
                        type: 'line',
                        data: [],
                        lineStyle: {
                            color: '#f1ae7e'
                        },
                        itemStyle: {
                            normal: {
                                color: '#f1ae7e'
                            }
                        }
                    },
                    {
                        name: '记账凭证',
                        type: 'line',
                        lineStyle: {
                            color: '#096ab4'
                        },
                        itemStyle: {
                            normal: {
                                color: '#096ab4'
                            }
                        },
                         data: [10, 20, 50, 30,40,28,49,76,39,2,99,10],

                    }
                ]
            };
            myChart.resize();
            myChart.setOption(option);
            myChart.showLoading();
            this.getCountEachMonthBookedFile(myChart);
        },
       
        getCountCurrMonthUploadFile(myChart) {
            //  获取每月上传文件数量统计
            fetchPost('/home/getYearSelectionAndGroupUploadFileList', {year:this.year})
                .then((res) => {
                    // myChart.setOption(option);
                    if (res.data.success) {
                        console.log(res.data.obj.xValueList);
                        myChart.hideLoading();
                        myChart.setOption({
                            xAxis: {
                                type: 'category',
                                data: res.data.obj.xValueList
                            },
                            series: [
                                {
                                    data: res.data.obj.countList
                                }
                            ]
                        });
                    } else {
                        this.$message.error('加载每月上传文件数量统计信息失败：' + res.data.message);
                    }
                })
                .catch((error) => {
                    this.$message.error('加载每月上传文件数量统计信息失败：' + error);
                });
        },
        getCountCurrMonthArchiveHandleData() {
            //  获取本月档案处理统计信息
            fetchPost('/home/getCountCurrMonthArchiveHandleData', '')
                .then((res) => {
                    if (res.data.success) {
                        this.countCurrMonthArchiveHandleDataForm = res.data.obj;
                    } else {
                        this.$message.error('加载本月档案处理统计信息失败：' + res.data.message);
                    }
                })
                .catch((error) => {
                    this.$message.error('加载本月档案处理统计信息失败：' + error);
                });
        },
        getCountBookedFile(myChart) {
            //  获取累计成册文件数量统计
            fetchPost('/home/getYearSelectAndEntityVolumeStatisticsList', { year: this.year })
                .then((res) => {
                    let dataOne = [];
                    let dataTwo = [];
                    var alldata = eval('(' + res.data + ')');
                    Object.keys(alldata.obj).map((key) => {
                        alldata.obj[key].map((item) => {
                            if (item.name == '已成册') {
                                dataOne.push(item.value);
                            } else if (item.name == '成册中') {
                                dataTwo.push(item.value);
                            }
                        });
                    });
                    let opt = [['product', '已成册', '成册中']];
                    for (let a = 1; a <= 12; a++) {
                        opt.push([a + '月', dataOne[a - 1], dataTwo[a - 1]]);
                    }
                    myChart.hideLoading();
                    myChart.setOption({ dataset: { source: [...opt] } });
                })
                .catch((error) => {
                    this.$message.error('加载累计成册文件数量统计信息失败：' + error);
                });
        },
        getCountCompanyUploadFile(myChart) {
            //  获取集团实体上传文件数量统计
            fetchPost('home/getYearSelectAndEntityGroupingStatisticsList', { year: this.year })
                .then((res) => {
                    let dataOne = [];
                    let dataTwo = [];
                    let dataThree = [];
                    var alldata = eval('(' + res.data + ')');
                    Object.keys(alldata.obj).map((key) => {
                        alldata.obj[key].map((item) => {
                            if (item.name == '已分组记账凭证') {
                                dataOne.push(item.value);
                            } else if (item.name == '未分组记账凭证') {
                                dataTwo.push(item.value);
                            } else {
                                dataThree.push(item.value);
                            }
                        });
                    });
                    let opt = [['product', '已分组记账凭证', '已分组原始凭证', '未分组记账凭证']];
                    for (let a = 0; a < 12; a++) {
                        opt.push([a+1 + '月', dataOne[a], dataThree[a], dataTwo[a]]);
                    }
                    myChart.hideLoading();
                    myChart.setOption({ dataset: { source: [...opt] } });
                })
                .catch((error) => {
                    this.$message.error('加载集团实体上传文件数量统计信息失败：' + error);
                });
        },
        getCountEachMonthBookedFile(myChart) {
            //  获取每月已成册文件数量统计
            var dataO = [];
            var dataT = [];
            fetchPost('/home/getYearSelectionAndEntityUploadFileList', { year: this.year })
                .then((res) => {
                    var alldata = eval('(' + res.data + ')');
                    Object.keys(alldata.obj).map((key) => {
                        alldata.obj[key].map((item) => {
                            if (item.name == '原始凭证') {
                                dataO.push(item.value);
                            } else {
                                dataT.push(item.value);
                            }
                        });
                    });
                    console.log(dataO);
                    console.log();

                    myChart.hideLoading();
                    myChart.setOption({
                        series: [
                            {
                                data: dataO
                            },
                            {
                                data: dataT
                            }
                        ]
                    });
                })
                .catch((error) => {
                    this.$message.error('加载每月成册文件数量统计信息失败：' + error);
                });
        },
    }
};
</script>

<style scoped>
.top-in {
    display: flex;
    flex-wrap: wrap;
    width: 230px;
    margin-right: 160px;
    align-items: center;
    align-content: center;
}
.in-top {
    font-size: 28px;
    font-weight: bold;
    color: #333333;
        white-space: nowrap;
}
.in-bottom {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
}
.top-logos{
    display: flex;
}
.box-home {
    height: 100%;
    min-height: 500px;
    min-width: 910px;
    position: relative;
}
.content {
    background: #f2f2f2;
}
.home-top {
    width: 100%;
    height: 159px;
    background: url('../../../assets/img/bakground-bg.svg') no-repeat;
    background-size: cover;
    /* background-attachment:fixed; */
    /* filter: blur(16px); */
    position: relative;
    border-radius: 10px;
}
.home-top-tiem{
    position: absolute;
left:10px;
top: 10px;
}
.home-top-option{
    display: flex;
    justify-content: center;
    width: 100%;
    height: 159px;

position: absolute;
left:0px;
top: 0px;
}
.home-top-img {
    min-width: 522px;
}
.home-in {
    margin-top: 16px;
    height: -webkit-calc((100% - 222px)/2);
    height: -moz-calc((100% - 222px)/2);
    height: calc((100% - 222px) / 2);
    display: flex;
}
.in-left {
    width: 50%;
    background: linear-gradient(180deg, #F7FAFF 0%, #eff7ff 100%);
    border-radius: 8px 8px 8px 8px;
}
.in-right {
    width: 50%;
    background: linear-gradient(180deg, #F7FAFF 0%, #eff7ff 100%);
    border-radius: 8px 8px 8px 8px;
    margin-left: 16px;
}
.home-bottom {
    margin-top: 16px;
    height: -webkit-calc((100% - 162px)/2);
    height: -moz-calc((100% - 162px)/2);
    height: calc((100% - 162px) / 2);
    display: flex;
}
.bottom-left {
    width: 100%;
    background: #f7faff;
    border-radius: 8px 8px 8px 8px;
}
.bottom-right {
    width: 100%;
    margin-left: 16px;
    background: #f7faff;
    border-radius: 8px 8px 8px 8px;
}
>>> .el-input__inner {
    width: 120px;
    height: 40px !important;
    background: #dce8ff;
    border-radius: 4px 4px 4px 4px;
    border: none;
}
>>> .el-icon-date:before {
    color: #333333;
}
>>> .el-input--small .el-input__icon {
    line-height: 42px;
}
</style>
